import {InternalToolsModulePermissionCodes} from 'utils/types';
import {defineTabDef} from 'utils/helpers';

export const campaignPlanningTabs = defineTabDef({
  calculator: {
    tabName: 'calculator',
    tabTitle: 'Calculator',
    requiredAnyPermission: [InternalToolsModulePermissionCodes.view_internal_tools],
  },
  'resource-center': {
    tabName: 'resource-center',
    tabTitle: 'Resource Center',
    requiredAnyPermission: [InternalToolsModulePermissionCodes.view_internal_tools],
  },
} as const);
